const ISO = "iso";
const UNS = "uns";
const ALPHANUM = "alphanum";

let unsSchema = null;
let alphanumSchema = null;

function getToothFileNameWithPrev(tooth) {
  let newNumber = tooth.newNumber ? +tooth.newNumber : +tooth.savedNumber;
  let fileName = `tooth_${newNumber}`; //`added(${i})`
  // let newNumberType = tooth.newNumberType
  // 	? tooth.newNumberType
  // 	: "primary";
  // if (newNumberType && newNumberType != "primary") {}
  // let newRemarks = tooth.newRemarks ? tooth.newRemarks : "";
  let newPrevTag = tooth.newPrevTag ? tooth.newPrevTag : tooth.prevTag;
  if (newPrevTag) {
    fileName += `-${newPrevTag}`;
  }
  return fileName;
}

function updateTeethNaming(teethNaming) {
  console.log("updateTeethNaming", teethNaming);
  vueApp.teethNaming = teethNaming;

  vueApp.allTeeth.forEach((tooth) => {
    updateDisplayNumberAndName(tooth);
  });

  vueApp.$emit("teethNamingChanged", teethNaming);
}

function updateDisplayNumberAndName(tooth) {
  let toothNumber = tooth.newNumber
    ? tooth.newNumber
    : tooth.savedNumber
    ? tooth.savedNumber
    : tooth.number;
  // console.log("updateDisplayNumberAndName", toothNumber, tooth);
  let teethNaming = vueApp.teethNaming;
  if (teethNaming == ISO) {
    tooth.displayNumber = toothNumber;
  } else if (teethNaming == UNS) {
    tooth.displayNumber = getUnsNumber(toothNumber);
  } else if (teethNaming == ALPHANUM) {
    tooth.displayNumber = getAlphanumNumber(toothNumber);
  }
  if (!tooth.displayNumber) {
    tooth.displayNumber = toothNumber;
  }
  let displayName = `tooth_${tooth.displayNumber}`;

  let newPrevTag = tooth.newPrevTag ? tooth.newPrevTag : tooth.prevTag;
  if (newPrevTag && newPrevTag.length > 0) {
    displayName += `-${newPrevTag}`;
  }
  let newAddedTag = tooth.newAddedTag ? tooth.newAddedTag : tooth.addedTag;
  if (newAddedTag && newAddedTag.length > 0) {
    displayName += `-${newAddedTag}`;
  }
  let newNumberType = tooth.newNumberType
    ? tooth.newNumberType
    : tooth.numberType;
  if (newNumberType && newNumberType != "primary" && newNumberType.length > 0) {
    displayName += `-${newNumberType}`;
  }
  let newRemarks = tooth.newRemarks ? tooth.newRemarks : tooth.remarks;
  if (newRemarks && newRemarks.length > 0) {
    displayName += `-${newRemarks}`;
  }
  tooth.displayName = displayName;
}

function getUnsNumber(toothNumber) {
  if (!unsSchema) {
    unsSchema = {};
    for (let i = 11, j = 8; i < 19; i++, j--) {
      unsSchema[i] = j;
    }
    for (let i = 21, j = 9; i < 29; i++, j++) {
      unsSchema[i] = j;
    }
    for (let i = 31, j = 24; i < 39; i++, j--) {
      unsSchema[i] = j;
    }
    for (let i = 41, j = 25; i < 49; i++, j++) {
      unsSchema[i] = j;
    }
  }
  return unsSchema[toothNumber];
}

function getAlphanumNumber(toothNumber) {
  if (!alphanumSchema) {
    alphanumSchema = {};
    for (let i = 11, j = 1; i < 19; i++, j++) {
      alphanumSchema[i] = "UR" + j;
    }
    for (let i = 21, j = 1; i < 29; i++, j++) {
      alphanumSchema[i] = "UL" + j;
    }
    for (let i = 31, j = 1; i < 39; i++, j++) {
      alphanumSchema[i] = "LR" + j;
    }
    for (let i = 41, j = 1; i < 49; i++, j++) {
      alphanumSchema[i] = "LL" + j;
    }
  }
  return alphanumSchema[toothNumber];
}

export { ISO, UNS, ALPHANUM, updateTeethNaming, updateDisplayNumberAndName };
